import React from "react";

const HowMatchingWorks = () => {
    return (
        <div className="min-h-screen bg-darkblue text-lightgray px-6 py-16">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl text-orange text-center mb-8">
                    How Matching Works
                </h1>

                <div className="space-y-8 text-lg">
                    <section>
                        <h2 className="text-2xl text-orange font-semibold mb-4">The Personality Assessment</h2>
                        <p>
                            CareerMission uses a proprietary personality inventory that measures key traits, motivations, and work style preferences. Candidates complete a series of questions that build a comprehensive career personality profile — capturing how they think, communicate, and approach their work.
                        </p>
                        <p className="mt-4">
                            The assessment is designed to surface stable, job-relevant characteristics rather than surface-level impressions. Results reflect consistent career personality tendencies that predict alignment with specific roles and team environments.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl text-orange font-semibold mb-4">How Scoring Works</h2>
                        <p>
                            Employers identify a Superstar Target — someone who has excelled in the role being filled. The system compares each candidate's personality profile against the target's profile, producing a match score that reflects career personality alignment.
                        </p>
                        <p className="mt-4">
                            Scores are calculated across multiple personality dimensions simultaneously, so the result represents overall fit rather than any single trait. This approach mirrors the multidimensional way people actually succeed or struggle in a role.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl text-orange font-semibold mb-4">What the Results Mean</h2>
                        <p>
                            Higher match scores indicate stronger alignment with the employer's ideal candidate profile. A high score does not guarantee a hire — it signals that the candidate's career personality patterns closely resemble those of someone who has proven themselves in a similar role.
                        </p>
                        <p className="mt-4">
                            Employers can review detailed breakdowns of how candidates compare across different personality dimensions, helping them understand not just who scored highest but why — and where trade-offs exist between candidates.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default HowMatchingWorks;
